document.addEventListener("DOMContentLoaded", function () {
  const tabItems = document.querySelectorAll(".tab-item");

  // Initialiser le premier tab comme actif
  const firstTab = tabItems[0];
  if (firstTab) {
    firstTab.classList.add("active");
    const content = firstTab.querySelector(".tab-item__content");
    content.style.maxHeight = content.scrollHeight + "px";
  }

  tabItems.forEach((item) => {
    item.addEventListener("click", function () {
      // Si ce tab est déjà actif, ne rien faire
      if (this.classList.contains("active")) {
        return;
      }

      // Fermer tous les autres tabs
      tabItems.forEach((tab) => {
        if (tab !== this) {
          tab.classList.remove("active");
          const content = tab.querySelector(".tab-item__content");
          content.style.maxHeight = "0";
        }
      });

      // Ouvrir le tab cliqué
      this.classList.add("active");
      const content = this.querySelector(".tab-item__content");
      content.style.maxHeight = content.scrollHeight + "px";
    });
  });
});
